import Model from './BaseModel';
import GroupedParentMarket from './GroupedParentMarket';

export default class MarketSetGroup extends Model {
	resourceName() {
		return 'market_set_groups';
	}

	fields() {
		return ['default_open', 'is_key', 'is_primary', 'market_group_id', 'market_group_set_id', 'name', 'order'];
	}

	relationships() {
		return {
			grouped_parent_markets: new GroupedParentMarket()
		};
	}
}
